import React from 'react'
import moment from 'moment'

export const POSTS = [
  {
    title: 'Date',
    dataIndex: 'form_values.b6e0',
    key: 'date',
    width: 50,
    render: date => {
      var str = date.split('-')
      var fYear = str[0],
        fMonth = str[1],
        fDay = str[2]

      return fDay + '-' + fMonth + '-' + fYear
    }
  },
  {
    title: 'Time',
    dataIndex: 'form_values.dabf',
    key: 'time',
    width: 50,
    className: 'hideThis'
  },
  {
    title: 'Job',
    dataIndex: 'job',
    key: 'job',
    width: 150
  },
  {
    title: 'Activity',
    dataIndex: 'form_values[9e7a]',
    key: 'activity',
    width: 150
  },
  {
    title: 'Posted by',
    dataIndex: 'form_values.e247.choice_values[0]',
    key: 'poster',
    width: 50,
    className: 'hideThis'
  }
]

export const ENQUIRY = (viewEnquiry, onUpdate) => [
  // {
  //   title: 'Status',
  //   dataIndex: 'status',
  //   key: 'status',
  //   render: (v, r) => <div onClick={() => console.log(v, r)}>{v}</div>
  // },
  {
    title: 'Date',
    dataIndex: 'form_values[ce91]',
    key: 'date',
    render: date => date && moment(date).format('Do MMM YY')
  },
  {
    title: 'Name',
    dataIndex: 'form_values[6612]',
    key: 'name'
  },
  {
    title: 'Phone',
    dataIndex: 'form_values[c0bc]',
    key: 'phone'
  },
  {
    title: 'Email',
    dataIndex: 'form_values[b89a]',
    key: 'email',
    className: 'hideThis'
  },
  {
    title: 'Address',
    dataIndex: 'form_values[ba02]',
    key: 'address',
    className: 'hideThis'
  },
  // {
  //   title: 'Bore Type',
  //   dataIndex: 'form_values[c2eb].choice_value[0]',
  //   key: 'type'
  // },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    render: (text, record) => {
      return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div style={{ color: '#40a9ff', cursor: 'pointer', padding: '0 2px' }} onClick={() => viewEnquiry(record)}>
            View
          </div>
          {/* {record.status === 'Enquiry' && }
          {record.status === 'Enquiry' && (
            
          )} */}
          <div style={{ padding: '0 2px' }}>|</div>
          <div style={{ color: '#40a9ff', cursor: 'pointer', padding: '0 2px' }} onClick={() => onUpdate(record, true)}>
            Dead
          </div>
        </div>
      )
    }
  }
]
